import { lazy } from 'react';

const CharityVettingTypeRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityVettingType" */ '../components/steps/charity-type-step/CharityType'
    ),
);

export default CharityVettingTypeRoute;
